<template>
  <div class="page">
    <h1>登录</h1>
    <form class="form" @submit.prevent="handleLogin">
      <label>
        用户名
        <input v-model.trim="form.username" type="text" required autocomplete="username" />
      </label>
      <label>
        密码
        <input v-model.trim="form.password" type="password" required autocomplete="current-password" />
      </label>
      <button type="submit" :disabled="loading">
        {{ loading ? '登录中...' : '登录' }}
      </button>
      <p v-if="error" class="error">{{ error }}</p>
    </form>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'LoginPage',
  data() {
    return {
      loading: false,
      error: '',
      form: {
        username: '',
        password: '',
      },
    }
  },
  methods: {
    async handleLogin() {
      this.error = ''
      this.loading = true
      try {
        const resp = await axios.post('/api/login', { ...this.form })
        localStorage.setItem('authUser', JSON.stringify(resp.data.data))
        const redirect = this.$route.query.redirect || '/admin'
        this.$router.replace(redirect)
      } catch (err) {
        if (err.response && err.response.data && err.response.data.message) {
          this.error = err.response.data.message
        } else {
          this.error = '登录失败，请稍后再试'
        }
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style scoped>
.page {
  max-width: 420px;
  margin: 0 auto;
  padding: 48px 24px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}
.form {
  display: flex;
  flex-direction: column;
  gap: 16px;
  background: #f7f9fb;
  padding: 24px;
  border-radius: 8px;
  border: 1px solid #e5e7eb;
}
label {
  display: flex;
  flex-direction: column;
  gap: 6px;
  color: #333;
}
input {
  height: 36px;
  padding: 0 10px;
  border: 1px solid #cbd5e1;
  border-radius: 6px;
}
button {
  height: 40px;
  background: #409eff;
  border: none;
  color: #fff;
  border-radius: 6px;
  cursor: pointer;
}
button[disabled] {
  opacity: 0.6;
  cursor: not-allowed;
}
.error {
  color: #d14343;
  margin: 0;
}
</style>

